<template lang="pug">
  app-modal.modalInformacao(
    :titulo="tituloModalDespacho",
    :width="width"
    :isDespacho='true'
    @closeModal="closeModal()"
  )
    template(slot="body")
      app-modal-selecionar-modelo-notificacao(
        v-if="idProcesso"
        :tiposModelo="tiposModelo",
        :titulo="'Modelos de Despacho'",
        :idProcesso="idProcesso"
        :showModal="showModalDespacho"
        @closeModal="fecharModalDespacho",
        @setTextoDespacho="setTextoDespacho"
      )
      div.extra-margin-top
        validation-observer(ref='validation' tag='form')
          el-row.margin-top
            el-col(:span="24")
              div.flex
                app-label.mt-20(
                  label="Mensagem:",
                  :required="true"
                )
                el-button.btn(
                  type="primary",
                  @click="openModalDespacho",
                )
                  span.center
                    i.fa.fa-file.icon
                    b &nbsp Modelo
              validation-provider(rules="required", v-slot="{ errors }")
                app-editor-texto.input(
                  :value="despacho.textoDespacho",
                  @onTextChange="onTextChange"
                  :class="{'erro' : errors.length}"
                  ref="editorTexto"
                )
                span.help.erro( v-if="errors.length" ) {{ errors[0] }}
          el-row.margin-top
            p.label.mt-20 Anexos mensagem
          el-row.margin-top
            validation-provider(v-slot="{ errors }")
              app-anexo(
                :id="'upload-anexo-despacho'"
                @removeFile="removeFile",
                @uploadFile="uploadFile"
                :files="despacho.documentos.filter(doc => doc.tipo.codigo === 'ANEXO_ANALISE')"
                scope="anexos",
                :errors="errors",
                :exibirDownload="false"
              )
              el-card(v-if="isArquivamentoPresidencia && !isReurbIndividual")
                  app-label(
                    label="Inclua a Carta de Notificação ao Interessado"
                    :required="isValidateCarta !== ''"
                  )
                  validation-provider(:rules="isValidateCarta", v-slot="{ errors }")
                    app-anexo(
                      :id="'upload-carta-notificacao'"
                      @uploadFile="uploadCartaNotificacao",
                      :files="cartas",
                      @removeFile="removeCartaNotificacao",
                      :showAnexar="true"
                      :errors="errors"
                      @downloadDocumentoCadastro="getDownload",
                      :tiposArquivosPermitidos="tiposArquivosPermitidosMapas"
                      v-model="cartas"
                      :showUpload="cartas.length === 0"
                    )
    template(slot="footer")
      .flex
        el-button.btn(
          type="default",
          size="small",
          @click="closeModal()"
        )
          span.center
            i.fa.fa-times
            b &nbsp Cancelar
        el-button.btn(
          type="success",
          size="small",
          @click="finalizarDespacho()"
        )
          span.center
            i.fa.fa-share-square
            b &nbsp Enviar
</template>

<script>
import AppLabel from '@/components/AppLabel'
import AppModal from '@/components/AppModal'
import AppAnexo from '@/components/AppAnexo'
import AppEditorTexto from '@/components/AppEditorTexto'
import AppDownloadArquivo from '@/components/AppDownloadArquivo'
import AppModalSelecionarModeloNotificacao from '../AppModalSelecionarModeloNotificacao'
const {tiposModeloDefault} = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  components: {
    AppModal,
    AppLabel,
    AppAnexo,
    AppDownloadArquivo,
    AppEditorTexto,
    AppModalSelecionarModeloNotificacao
  },

  props: {
    width: {
      type: Number,
      default: 850
    },
    idProcesso: {
      required: true
    },
    acao: {
      required: true
    },
    tituloModalDespacho: {
      required: true
    },
    tipoProcesso: {
      required: false,
      type: String
    }
  },

  data () {
    return {
      despacho: {
        idProcesso: this.idProcesso,
        acao: this.acao,
        textoDespacho: '',
        documentos: []
      },
      cartas: [],
      tiposArquivosPermitidosMapas: '.png, .jpg, .jpeg, .pdf, .doc, .docx',
      showModalDespacho: false,
      tiposModelo: tiposModeloDefault
    }
  },
  methods: {
    async uploadFile (file) {
      this.despacho.documentos.push({
        key: file.response,
        nome: file.name,
        tipo: {
          id: 51,
          codigo: 'ANEXO_ANALISE'
        }
      })
    },
    removeFile (file) {
      const arquivo = this.despacho.documentos.findIndex(obj => obj === file)
      this.despacho.documentos.splice(arquivo, 1)
      if (file.tipo.codigo === 'CARTA_NOTIFICACAO_INTERESSADO') {
        this.cartas = []
      }
    },
    uploadCartaNotificacao (file) {
      this.cartas.push({
        key: file.response,
        nome: file.name,
        tipo: {
          id: 341,
          codigo: 'CARTA_NOTIFICACAO_INTERESSADO'
        }
      })
      this.setCartaNotificacaoInteressado()
    },

    removeCartaNotificacao (documento) {
      const index = this.cartas.findIndex(m => m.key === documento.key)

      if (index !== -1) {
        this.cartas.splice(index, 1)
      }

      if (documento.tipo.codigo === 'CARTA_NOTIFICACAO_INTERESSADO') {
        this.despacho.documentos = this.despacho.documentos.filter(doc => doc.key !== documento.key)
      }
    },
    async checkValidacao () {
      const valido = await this.$refs.validation.validate()
      if (!valido) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Por favor, preencha os campos obrigatórios.')
        return false
      }
      return true
    },
    closeModal () {
      this.$emit('closeModal')
    },
    onTextChange (value) {
      this.despacho.textoDespacho = value
    },
    async finalizarDespacho () {
      if (!await this.checkValidacao()) {
        return
      }
      this.$emit('finalizar', this.despacho)
    },
    openModalDespacho () {
      this.showModalDespacho = true
    },

    fecharModalDespacho () {
      this.showModalDespacho = false
    },
    setTextoDespacho (textoDespacho) {
      this.$refs.editorTexto.text = textoDespacho
      this.$refs.editorTexto.emitTextChange()
    },
    removeNull (value) {
      if (value) {
        return value
      }

      return '-'
    },
    setCartaNotificacaoInteressado () {
      this.cartas.forEach(carta => {
        this.despacho.documentos.push(carta)
      })
    }
  },

  computed: {
    isValidateCarta () {
      return this.despacho.documentos.some(doc => doc.tipo.codigo === 'CARTA_NOTIFICACAO_INTERESSADO') ? '' : 'required'
    },
    isArquivamentoPresidencia () {
      return this.acao?.includes('ARQUIVAMENTO') && !this?.dadosCadastros?.despacho?.acao?.includes('DESARQUIVAMENTO')
    },
    isMaranhao () {
      return process.env.ESTADO === 'ma'
    },
    isReurbIndividual () {
      return ['REURB_INDIVIDUAL'].includes(this.tipoProcesso)
    }
  }
}
</script>

<style scoped lang="scss">
p.message {
  width: 80%;
  margin: 0 auto;
}

.flex {
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mt-20 {
  margin-top: 20px;
}

.extra-margin-top {
  margin-top: 15px !important;
}

@media (max-width: 780px) {
  .modalInformacao {
    width: 360px !important;
    position: fixed !important;
  }
}
.btn-despacho {
  display: flex;
  justify-content: end;
}
.btn {
  padding: 7px;
  height: 35px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/modal/AppModalDespachoPresidente.vue